import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecommendationsPanel = () => {
  const recommendations = [
    {
      id: 1,
      type: 'bottleneck',
      priority: 'high',
      title: 'Technical Interview Bottleneck',
      description: 'Technical interviews are taking 45% longer than target. Consider adding more interviewers or streamlining the process.',
      impact: 'Could reduce time-to-hire by 8 days',
      action: 'Review technical interview process',
      icon: 'AlertTriangle'
    },
    {
      id: 2,
      type: 'opportunity',
      priority: 'medium',
      title: 'LinkedIn Source Optimization',
      description: 'LinkedIn generates 35% of applications but only 22% conversion rate. Improve job posting quality or targeting.',
      impact: 'Potential 15% increase in qualified candidates',
      action: 'Optimize LinkedIn job postings',
      icon: 'TrendingUp'
    },
    {
      id: 3,
      type: 'success',
      priority: 'low',
      title: 'Marketing Department Excellence',
      description: 'Marketing team has 92% offer acceptance rate, highest across all departments. Consider sharing best practices.',
      impact: 'Could improve overall acceptance by 8%',
      action: 'Document and share best practices',
      icon: 'Award'
    },
    {
      id: 4,
      type: 'warning',
      priority: 'medium',
      title: 'Design Team Hiring Delays',
      description: 'Design positions average 35 days to hire, 40% above company target. Review requirements and process.',
      impact: 'Missing talent due to extended timelines',
      action: 'Streamline design hiring process',
      icon: 'Clock'
    }
  ];

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'text-error';
      case 'medium': return 'text-warning';
      case 'low': return 'text-success';
      default: return 'text-muted-foreground';
    }
  };

  const getPriorityBg = (priority) => {
    switch (priority) {
      case 'high': return 'bg-error/10';
      case 'medium': return 'bg-warning/10';
      case 'low': return 'bg-success/10';
      default: return 'bg-muted/10';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'bottleneck': return 'AlertTriangle';
      case 'opportunity': return 'TrendingUp';
      case 'success': return 'Award';
      case 'warning': return 'Clock';
      default: return 'Info';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">AI-Powered Recommendations</h3>
        <div className="flex items-center space-x-2">
          <Icon name="Sparkles" size={16} className="text-primary" />
          <span className="text-sm text-muted-foreground">Based on your data patterns</span>
        </div>
      </div>
      <div className="space-y-4">
        {recommendations?.map((rec) => (
          <div key={rec?.id} className="border border-border rounded-lg p-4 hover:shadow-sm transition-shadow">
            <div className="flex items-start space-x-4">
              <div className={`p-2 rounded-lg ${getPriorityBg(rec?.priority)}`}>
                <Icon name={getTypeIcon(rec?.type)} size={20} className={getPriorityColor(rec?.priority)} />
              </div>
              
              <div className="flex-1 space-y-2">
                <div className="flex items-center justify-between">
                  <h4 className="font-medium text-foreground">{rec?.title}</h4>
                  <span className={`text-xs px-2 py-1 rounded-full ${getPriorityBg(rec?.priority)} ${getPriorityColor(rec?.priority)} font-medium`}>
                    {rec?.priority?.toUpperCase()}
                  </span>
                </div>
                
                <p className="text-sm text-muted-foreground">{rec?.description}</p>
                
                <div className="flex items-center justify-between pt-2">
                  <div className="text-xs text-success font-medium">{rec?.impact}</div>
                  <Button variant="outline" size="sm">
                    {rec?.action}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Recommendations updated daily based on your hiring data
          </div>
          <Button variant="ghost" size="sm" iconName="RefreshCw" iconPosition="left">
            Refresh Analysis
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RecommendationsPanel;